"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseActiveTenants = parseActiveTenants;
function parseActiveTenants(activeTenantsBlob) {
  return typeof activeTenantsBlob === 'string' && activeTenantsBlob !== '' ? activeTenantsBlob.split(',').map(tenant => tenant.trim().toLowerCase()).filter(Boolean) : [];
}
